<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <canvas ref="netEnergyChart" class="chart-height"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

// Register the plugin
Chart.plugins.register(ChartDataLabels);
// Set the default font size
Chart.defaults.global.defaultFontSize = 14;

export default {
  name: "NetEnergyBarChart",
  props: {
    ASR: {
      type: Number,
      required: true
    },
    OLR: {
      type: Number,
      required: true
    },
    isBalanced: {
      type: Boolean,
      required: true
    }
  },
  mounted() {
    this.createChart();
  },
  watch: {
    ASR: "updateChart",
    OLR: "updateChart",
    isBalanced: "updateChart"
  },
  methods: {
    createChart() {
      const ctx = this.$refs.netEnergyChart.getContext("2d");
      this.chart = new Chart(ctx, {
        type: "horizontalBar",
        data: {
          labels: ["Absorbed sunlight", "Emitted IR radiation"],
          datasets: [
            {
              label: " Energy",
              data: [this.ASR, -this.OLR],
              backgroundColor: [
                this.isBalanced ? "green" : "yellow", // ASR
                this.isBalanced ? "green" : "red" // OLR
              ]
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          plugins: {
            datalabels: {
              clip: false,
              color: (context) =>
                context.dataIndex === 0 ? "#000" : "#f8f8f8",
              align: function (context) {
                // If the first column (dataIndex 0), align the label at the end; otherwise, at the start
                return context.dataIndex === 0 ? "start" : "end";
              },
              anchor: function () {
                // return context.dataIndex === 0 ? "start" : "end";
                return "center";
              },
              font: {
                weight: "bold"
              },
              formatter: function (value) {
                return value.toPrecision(4);
              }
            }
          },
          scales: {
            xAxes: [
              {
                gridLines: {
                  color: "#f8f8f8",
                  zeroLineColor: "#f8f8f8"
                },
                ticks: {
                  fontColor: "#f8f8f8"
                },
                scaleLabel: {
                  display: true,
                  labelString: "Energy (Wm\u207B\u00B2)",
                  fontColor: "#f8f8f8"
                }
              }
            ],
            yAxes: [
              {
                gridLines: {
                  color: "#f8f8f8",
                  zeroLineColor: "#f8f8f8"
                },
                ticks: {
                  fontColor: "#f8f8f8"
                }
              }
            ]
          },
          title: {
            display: true,
            text: "Net radiant energy",
            fontColor: "#f8f8f8"
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem) {
                const value = tooltipItem.xLabel;
                return value.toPrecision(4);
              }
            }
          }
        }
      });
    },
    updateChart() {
      if (this.chart) {
        this.chart.data.datasets[0].data = [this.ASR, -this.OLR];
        this.chart.data.datasets[0].backgroundColor = [
          this.isBalanced ? "green" : "yellow", // ASR
          this.isBalanced ? "green" : "red" // OLR
        ];
        this.chart.update();
      }
    }
  }
};
</script>

<style scoped>
.chart-height {
  height: 150px !important;
}
</style>
